var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowForward = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 72 72",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "arrow-forward-a",
    d: "M47.1675319,42.2087621 C27.2962109,40.2089919 8.44611699,46.6552145 0.719008264,62 C3.08043379,41.0806143 19.8494107,24.0787332 47.4567493,22.0804552 L41.5652748,16.1889808 C41.1884249,15.8121309 41,15.365247 41,14.848329 C41,14.3314111 41.1884249,13.8845272 41.5652748,13.5076773 L46.4776628,8.56527479 C46.8545126,8.18842493 47.3063989,8 47.8333218,8 C48.3602446,8 48.8121309,8.18842493 49.1889808,8.56527479 L71.2530397,30.6593483 C71.6298895,31.0361982 71.8183145,31.4830821 71.8183145,32 C71.8183145,32.5169179 71.6298895,32.9638018 71.2530397,33.3406517 L49.1889808,55.4347252 C48.8121309,55.8115751 48.3602446,56 47.8333218,56 C47.3063989,56 46.8545126,55.8115751 46.4776628,55.4347252 L41.5652748,50.4923227 C41.1884249,50.1154728 41,49.6685889 41,49.151671 C41,48.634753 41.1884249,48.1878691 41.5652748,47.8110192 L47.1675319,42.2087621 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arrow-forward-a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowForward);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-forward.abdc790206121334702fd050f5b889a4.svg";